import locales from '../../content.json';

export function getLocalizedError(error: string | { message: string }): string {
  const lang = window.userLang || 'en';
  const message = typeof error === 'string' ? error : error.message;

  switch (message) {
    case 'Subscription not activated, not paid)':
      return locales[lang].error_1;
    case 'Your card was declined.':
      return locales[lang].error_2;
    case 'Your card has insufficient funds.':
      return locales[lang].error_3;
    case 'Your card has expired.':
      return locales[lang].error_4;
    case 'An error occurred while processing your card. Try again in a little bit.':
      return locales[lang].error_5;
    case "Your card's security code is incorrect.":
      return locales[lang].error_6;
    case 'Your Stripe account cannot currently process American Express cards. Please contact us via https://support.stripe.com/contact if you have any questions.':
      return locales[lang].error_7;
    case 'User with this email already has app_usage active subscription.':
      return locales[lang].error_9;
    case 'Your card was declined for making repeated attempts too frequently or exceeding its amount limit.':
      return locales[lang].error_10;
    default:
      return locales[lang].error_8;
  }
}
